import React, { useEffect, useState } from 'react';
import LoanTakenField from './LoanTakenField';


const AddLoanTaken = () => {
     return (
        <div className='mx-auto p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A Loan Taken</h1>
            <LoanTakenField></LoanTakenField>
        </div>
    );
};

export default AddLoanTaken;